module.exports = __webpack_public_path__ + "static/media/Print.aab16065.svg";